import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const OrderFilters = ({ onFilterChange, onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedTimeRange, setSelectedTimeRange] = useState('today');

  const statusOptions = [
    { value: 'all', label: 'All Orders' },
    { value: 'active', label: 'Active' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'disputed', label: 'Disputed' }
  ];

  const timeRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch?.(searchTerm);
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    onFilterChange?.({ status, timeRange: selectedTimeRange });
  };

  const handleTimeRangeChange = (timeRange) => {
    setSelectedTimeRange(timeRange);
    onFilterChange?.({ status: selectedStatus, timeRange });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-end">
        {/* Search */}
        <div className="lg:col-span-4">
          <form onSubmit={handleSearch} className="relative">
            <Input
              type="search"
              placeholder="Search by Order ID or Customer..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              className="pr-10"
            />
            <Button
              type="submit"
              variant="ghost"
              size="icon"
              className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8"
            >
              <Icon name="Search" size={16} />
            </Button>
          </form>
        </div>

        {/* Status Filter */}
        <div className="lg:col-span-3">
          <Select
            label="Order Status"
            options={statusOptions}
            value={selectedStatus}
            onChange={handleStatusChange}
          />
        </div>

        {/* Time Range */}
        <div className="lg:col-span-3">
          <Select
            label="Time Range"
            options={timeRangeOptions}
            value={selectedTimeRange}
            onChange={handleTimeRangeChange}
          />
        </div>

        {/* Actions */}
        <div className="lg:col-span-2 flex space-x-2">
          <Button variant="outline" iconName="Filter" size="sm">
            Advanced
          </Button>
          <Button variant="ghost" iconName="RefreshCw" size="sm">
            Refresh
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderFilters;